import React from 'react';
import { classNames } from '../../utils/style';
import { Image } from '../Image';

export const ImageMozaic = ({ image, sizes, className }: any) => {
  return (
    <div className={className}>
      <div
        className={classNames(
          `MosaicImage bg-white rounded-12 overflow-hidden`,
        )}
      >
        {image && (
          <Image
            {...image}
            className={classNames(
              image?.className,
              'w-full h-full object-cover',
            )}
            sizes={sizes}
          />
        )}
      </div>
    </div>
  );
};
